import { __rest } from "tslib";
const name = 'Flash';
const properties = {
    schema: {},
};
/**
 * Flash animation object
 */
function animate(kit, elements, duration, delay, _a = {}) {
    var { easing = 'cubicInOut' } = _a, params = __rest(_a, ["easing"]);
    const sequence = kit.sequence(params);
    sequence
        .add(kit.animate('BaseFade', elements, duration / 2, 0, {
        to: { opacity: 0.0001 },
        ease: easing,
    }))
        .add(kit.animate('BaseFade', elements, duration / 2, 0, {
        to: { opacity: 1 },
        ease: easing,
    }))
        .add(kit.animate('BaseNone', elements, delay, 0)); // add repeat delay
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=flash.js.map